import { HttpContextToken } from '@angular/common/http';
import { GlobalConstants } from '../../constant/constant';

export const HTTP_REQUEST_TIMEOUT_MS = new HttpContextToken<number>(() => GlobalConstants.CALL_DUE_TIME_MS);